module.exports = __webpack_public_path__ + "static/media/evening-passed-icon.11a8c4cc.png";